<span class="hover--link" (click)="doExport()">
  <pdf-icon [cssClass]="'export--size'"></pdf-icon>
</span>